import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { EMAIL_SIGNATURE_ACTION_TYPE } from '../actions';

const initialState = null;

const emailSignatureReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case EMAIL_SIGNATURE_ACTION_TYPE.GET_EMAIL_SIGNATURE:
      case EMAIL_SIGNATURE_ACTION_TYPE.CREATE_EMAIL_SIGNATURE:
      case EMAIL_SIGNATURE_ACTION_TYPE.UPDATE_EMAIL_SIGNATURE:
        return payload || state;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default emailSignatureReducer;
